module.exports = __webpack_public_path__ + "static/media/brego3591.7b7f68cc.jpg";